// extracted by mini-css-extract-plugin
export default {"Error":"NotFound_Error__nTznu"};